import React from 'react';

export const props = {
  url: null,
  type: null,
  open: (url, type) => {},
}

const PreviewModalContext = React.createContext(props);

export default PreviewModalContext;